import { Link } from 'react-router-dom';
import { useAdminStore, selectIsSuperAdmin } from '@/stores/adminStore';
import { Card } from '@/components/common/Card';
import { Button } from '@/components/common/Button';
import * as adminApi from '@/api/admin';

interface SectionLink {
  path: string;
  title: string;
  description: string;
  superAdminOnly?: boolean;
}

const SECTIONS: SectionLink[] = [
  {
    path: '/admin/keys',
    title: 'Keys',
    description:
      'Manage shared API keys (OpenAI, Gemini, Jira, etc.) and the GitHub App configuration.',
  },
  {
    path: '/admin/releases',
    title: 'Desktop Releases',
    description:
      'Pin a specific TDA desktop version for rollback, or resume normal latest.json flow.',
  },
  {
    path: '/admin/admins',
    title: 'Admins',
    description:
      'Add or remove admin users. Requires super_admin role.',
    superAdminOnly: true,
  },
];

export default function AdminHomePage() {
  const { admin, clearAdmin } = useAdminStore();
  const isSuperAdmin = useAdminStore(selectIsSuperAdmin);

  const handleLogout = async () => {
    try {
      await adminApi.logout();
    } finally {
      clearAdmin();
    }
  };

  const visible = SECTIONS.filter(
    (s) => !s.superAdminOnly || isSuperAdmin
  );

  return (
    <div className="min-h-screen bg-md-cream py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-md-graphite">Admin</h1>
            <p className="text-sm text-md-slate mt-1">
              Signed in as {admin?.email} ({admin?.role})
            </p>
          </div>
          <Button variant="secondary" size="sm" onClick={handleLogout}>
            Logout
          </Button>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {visible.map((s) => (
            <Link key={s.path} to={s.path} className="block">
              <Card interactive className="h-full">
                <h2 className="text-xl font-bold text-md-graphite mb-2">
                  {s.title}
                </h2>
                <p className="text-sm text-md-slate">{s.description}</p>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
